import ChunkLoadError from './ChunkLoadError';

export default ChunkLoadError;
